import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';

import ProgressNavi from '../ProgressNavi.js';
import DetectionTestRightPlayer from '../../containers/Detections/DetectionTestRightPlayer.js';
import DetectionTestLeftPlayer from '../../containers/Detections/DetectionTestLeftPlayer.js';
import Helpers from '../../helpers';

const styles = {
  wrap: {
    padding: 10,
    display: 'block',
    height: 'calc(100vh - 150px)',
  },
  wrap_TV: {
    padding: '43% 10px 10px 10px',
    display: 'block',
  }
};

class DetectionTestViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      volume: 50,
      muted: false,
    };
  }

  render() {
    const {
      params,
    } = this.props;

    var wrap = styles.wrap;

    if (Helpers.Session.isViaTV()) {
      wrap = styles.wrap_TV;
    }

    return (
      <div style={wrap}>
        <ProgressNavi
          step={parseInt(params.key, 10)}
          count={4}
          color={params.type === 'right' ? '#FBBB0C' : '#5CBDE7'} />
        {params.type === 'right' &&
          <DetectionTestRightPlayer
            stepKey={parseInt(params.key, 10)}
            count={4} />
        }
        {params.type === 'left' &&
          <DetectionTestLeftPlayer
            stepKey={parseInt(params.key, 10)}
            count={4} />
        }
      </div>
    );
  }
}

DetectionTestViewer.propTypes = {
  params: T.shape({
    key: T.string,
    type: T.string,
  }),
};

export default radium(DetectionTestViewer);



// WEBPACK FOOTER //
// ./components/Detections/DetectionTestViewer.js